<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" :key="key" />
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" :key="key" />
    <tabbar-new-new v-if="$route.meta.showTab" />
    <loading />
    <skeleton />
  </div>
</template>

<script>
import TabbarNewNew from './components/Tabbar/indexNewNew.vue'
import { fpjsGetVisitorDataExtendedMixin } from '@fingerprintjs/fingerprintjs-pro-vue-v2'
import Loading from './components/Loading'
import Skeleton from './components/Skeleton'
export default {
  components: {
    TabbarNewNew,
    Loading,
    Skeleton
  },
  mixins: [fpjsGetVisitorDataExtendedMixin],
  data() {
    return {
      isNew: null
    }
  },
  computed: {
    key() {
      return this.$route.fullPath
    }
  },
  async created() {
    // 在页面加载时读取sessionStorage
    if (sessionStorage.getItem('store')) {
      this.$store.replaceState(Object.assign({}, this.$store.state, JSON.parse(sessionStorage.getItem('store'))))
    }
    // 在页面刷新时将store保存到sessionStorage里
    window.addEventListener('beforeunload', () => {
      sessionStorage.setItem('store', JSON.stringify(this.$store.state))
    })
    if (!localStorage.getItem('visitorId')) {
      await this.$getVisitorDataExtended()
      const visitorId = this.visitorDataExtended?.data?.visitorId
      if(visitorId){
        localStorage.setItem('visitorId', visitorId)
      }
    }
  },
  mounted() {
    console.log('主题'+ process.env.VUE_APP_BASE_THEME)
    if(process.env.VUE_APP_BASE_THEME){
      document.body.classList.toggle(process.env.VUE_APP_BASE_THEME);
    }else{
      // document.body.classList.toggle('light-theme');
    }
  },
}
</script>
<style scoped>
  #app {
    position: relative;
    width: 100%;
    height: 100%;
    padding: 0;
    /* background: #151e34; */
    /* background: #f5f5f5; */
  }
</style>
